import { frontendURL } from '../../../../helper/URLHelper';
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import SettingsWrapper from '../SettingsWrapper.vue';

// Lazy: the page uses Ant Design, which stays out of the main dashboard bundle.
const Codex = () => import('./Index.vue');

// Every agent (2026-10-16): each sees their own token and config.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/codex'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'codex_settings_index',
          component: Codex,
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
